import { render } from "./AppleSSO.vue?vue&type=template&id=6c318075&scoped=true"
import script from "./AppleSSO.vue?vue&type=script&lang=js"
export * from "./AppleSSO.vue?vue&type=script&lang=js"

import "../../assets/css/Elements/AppleSSO.css?vue&type=style&index=0&id=6c318075&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c318075"]])

export default __exports__